// import logo from '../../../../shared/img/logo/logo_MW.png';
// import instaLogo from '../../../../shared/img/logo/insta_logo.png';

import { formatMinutes } from '../../../../helpers/utils';

const addSlideProgram = (pptx, addBrandingToSlide, year, index) => {
  // presentation slide
  const slideProgram = pptx.addSlide({ masterName: 'COMPANY_BRANDING' });
  slideProgram.addText(`PROGRAMME ANNEE ${index + 1}`, {
    x: 1.25,
    y: 0.25,
    w: 8,
    h: 0.5,
    align: 'center',

    // Style du texte
    fontSize: 22,
    color: '4f4f4f',
    bold: true,

    // Style de la forme
    shape: pptx.ShapeType.rect,
    fill: { color: 'fae3f2' },

    // Bordure
    line: {
      color: 'f71616', // rouge foncé
      width: 1, // épaisseur de la bordure
    },
  });

  // Semestres impairs
  slideProgram.addText(`Semestre ${year[0].semester} ${year[0].adminData
    ? `- ${formatMinutes(year[0].adminData?.elearningHours)} (E-learning) ${year[0].adminData?.presentialHours
      ? `+ ${formatMinutes(year[0].adminData?.presentialHours)} (cours)`
      : ''}`
    : ''}`, {
    x: 0.5,
    y: 1.5,
    w: 5,
    h: 0.5,
    align: 'left',
    fontSize: 16,
    color: 'fc1e1e',
    bold: true,
  });
  let y1 = 2;
  year[0].courses[0].filledModules.forEach((module) => {
    slideProgram.addShape(pptx.ShapeType.ellipse,
      {
        fill: {
          type: 'solid',
          color: '696969',
        },
        x: 0.5,
        y: y1 + 0.25,
        w: 0.05,
        h: 0.05,
      });

    slideProgram.addText(module.name, {
      x: 0.75,
      y: y1,
      w: 4,
      h: 0.5,
      align: 'left',
      fontSize: 15,
      color: '696969',
      bold: true,
    });
    y1 += 0.40;
  });

  if (year[1]) {
    // Semestres pairs
    slideProgram.addText(`Semestre ${year[1].semester} ${year[1].adminData
      ? `- ${formatMinutes(year[1].adminData?.elearningHours)} (E-learning) ${year[1].adminData?.presentialHours
        ? `+ ${formatMinutes(year[1].adminData?.presentialHours)} (cours)`
        : ''}`
      : ''}`, {
      x: 5.5,
      y: 1.5,
      w: 4,
      h: 0.5,
      align: 'left',
      fontSize: 16,
      color: 'fc1e1e',
      bold: true,
    });
    let y2 = 2;
    year[1].courses[0].filledModules.forEach((module) => {
      slideProgram.addShape(pptx.ShapeType.ellipse,
        {
          fill: {
            type: 'solid',
            color: '696969',
          },
          x: 5.5,
          y: y2 + 0.25,
          w: 0.05,
          h: 0.05,
        });

      slideProgram.addText(module.name, {
        x: 5.75,
        y: y2,
        w: 4,
        h: 0.5,
        align: 'left',
        fontSize: 15,
        color: '696969',
        bold: true,
      });
      y2 += 0.40;
    });
  }

  addBrandingToSlide(pptx, slideProgram);
};

export default addSlideProgram;
